import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { matar } from "../../../api/index.js";
import { toast } from "react-toastify";
import Plot from "react-plotly.js";
import { useNavigate } from "react-router-dom";

const WorkOrderDetail = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [assetData, setAssetData] = React.useState(null);
  const [chartQuarter, setChartQuarter] = React.useState([]);
  const [chart, setChart] = React.useState([]);
  async function getData() {
    try {
      const result = await matar.customMatar({
        method: "GET",
        url: "/api/v1/assets/" + params.id,
        queryParams: {},
      });
      if (result.ok) {
        const body = await result.json();
        setAssetData(body.data?.data);
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    } finally {
    }
  }
  async function getDataChartQuarter() {
    try {
      const result = await matar.customMatar({
        method: "POST",
        url: "/api/v1/assets/" + params.id,
        queryParams: { chart: "WOandFailQuarter" },
      });
      if (result.ok) {
        const body = await result.json();
        const data = body.data?.data;
        const charts = [];
        const one = {
          x: [],
          y: [],
          type: "line",
          name: "Corrective Work Order Count",
          mode: "lines+markers",
          marker: { color: "#f39710" },
        };
        const two = {
          x: [],
          y: [],
          type: "line",
          name: "Failure Count",
          mode: "lines+markers",
          marker: { color: "#2fb5c9" },
        };
        const three = {
          x: [],
          y: [],
          type: "line",
          name: "Preventive Work Order Count",
          mode: "lines+markers",
          marker: { color: "#3bd2a2" },
        };
        data.forEach((item) => {
          // change Time to Quarter (Q1, Q2, Q3, Q4)
          // if Jan, Feb, Mar => Q1 - Year
          // if Apr, May, Jun => Q2 - Year
          // if Jul, Aug, Sep => Q3 - Year
          // if Oct, Nov, Dec => Q4 - Year
          let month = new Date(item["Time"]).getMonth();
          let quarter = "";
          if (month >= 0 && month <= 2) {
            quarter = "Q1";
          }
          if (month >= 3 && month <= 5) {
            quarter = "Q2";
          }
          if (month >= 6 && month <= 8) {
            quarter = "Q3";
          }
          if (month >= 9 && month <= 11) {
            quarter = "Q4";
          }
          one.x.push(quarter + " - " + new Date(item["Time"]).getFullYear());
          two.x.push(quarter + " - " + new Date(item["Time"]).getFullYear());
          three.x.push(quarter + " - " + new Date(item["Time"]).getFullYear());

          // one.x.push(item["Time"])
          // two.x.push(item["Time"])
          // three.x.push(item["Time"])

          one.y.push(item["Corrective Work Order Count"]);
          two.y.push(item["Failure Count"]);
          three.y.push(item["Preventive Work Order Count"]);
        });
        charts.push(one);
        charts.push(two);
        charts.push(three);
        setChartQuarter(charts);
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    } finally {
    }
  }
  async function getDataChart() {
    try {
      const result = await matar.customMatar({
        method: "POST",
        url: "/api/v1/assets/" + params.id,
        queryParams: { chart: "WOandFail" },
      });
      if (result.ok) {
        const body = await result.json();
        const data = body.data?.data;
        const charts = [];
        const one = {
          x: [],
          y: [],
          type: "bar",
          name: "Corrective Work Order Count",
          marker: { color: "#f39710" },
        };
        const two = {
          x: [],
          y: [],
          type: "bar",
          name: "Failure Count",
          marker: { color: "#2fb5c9" },
        };
        const three = {
          x: [],
          y: [],
          type: "bar",
          name: "Preventive Work Order Count",
          marker: { color: "#3bd2a2" },
        };
        data.forEach((item) => {
          one.x.push(item["Year"]);
          two.x.push(item["Year"]);
          three.x.push(item["Year"]);

          one.y.push(item["Corrective Work Order Count"]);
          two.y.push(item["Failure Count"]);
          three.y.push(item["Preventive Work Order Count"]);
        });
        charts.push(one);
        charts.push(two);
        charts.push(three);
        setChart(charts);
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    } finally {
    }
  }
  useEffect(() => {
    getData();
    getDataChart();
    getDataChartQuarter();
  }, []);
  return (
    <div style={{ m: 5 }}>
      <div p={5} className="widget" style={{ height: "auto", padding: "20px" }}>
        <div className="widget-wrapper">
          <div style={{ fontWeight: "bold", mb: 2 }}>
            Asset ID : {params.id}
          </div>
          <div>
            <table>
              <tr>
                <td>Asset Description</td>
                <td style={{ paddingRight: "5px", paddingLeft: "5px" }}>:</td>
                <td>{assetData?.asset_description}</td>
              </tr>
              <tr>
                <td>Asset Group</td>
                <td style={{ paddingRight: "5px", paddingLeft: "5px" }}>:</td>
                <td>{assetData?.asset_group}</td>
              </tr>
              <tr>
                <td>Asset Level</td>
                <td style={{ paddingRight: "5px", paddingLeft: "5px" }}>:</td>
                <td>{assetData?.asset_level}</td>
              </tr>
              <tr>
                <td>Asset Criticality</td>
                <td style={{ paddingRight: "5px", paddingLeft: "5px" }}>:</td>
                <td>{assetData?.asset_criticality}</td>
              </tr>
              <tr>
                <td>Asset Location</td>
                <td style={{ paddingRight: "5px", paddingLeft: "5px" }}>:</td>
                <td>{assetData?.location}</td>
              </tr>
            </table>
          </div>
          <hr />
          <div style={{ height: "500px" }}>
            <h4>Work Order and Failure History</h4>
            <Plot
              style={{ display: "block" }}
              data={chart}
              layout={{
                legend: {
                  bgcolor: "#595959",
                },
                autosize: true,
                font: {
                  color: "#eaeaea",
                },
                xaxis: {
                  gridcolor: "#506784",
                  linecolor: "#506784",
                  title: {
                    text: "Count",
                    font: {
                      size: 13,
                      color: "#efefef",
                    },
                  },
                },
                yaxis: {
                  gridcolor: "#506784",
                  linecolor: "#506784",
                  title: {
                    text: "Time",
                    font: {
                      size: 13,
                      color: "#eaeaea",
                    },
                  },
                },
                displayModeBar: false,
              }}
              config={{
                showlegend: true,
                displayModeBar: false,
                editable: false,
                scrollZoom: false,
                responsive: true,
                staticPlot: false,
              }}
            />
          </div>
          <hr />
          <div style={{ height: "500px" }}>
            <h4>Work Order and Failure History - Quarter</h4>
            <Plot
              style={{ display: "block" }}
              data={chartQuarter}
              layout={{
                legend: {
                  bgcolor: "#595959",
                },
                autosize: true,
                font: {
                  color: "#eaeaea",
                },
                displayModeBar: false,
                xaxis: {
                  gridcolor: "#506784",
                  linecolor: "#506784",
                  textColor: "#eaeaea",
                  title: {
                    text: "Time",
                    font: {
                      size: 13,
                      color: "#efefef",
                    },
                  },
                },
                yaxis: {
                  gridcolor: "#506784",
                  linecolor: "#506784",
                  title: {
                    text: "Count",
                    font: {
                      size: 13,
                      color: "#eaeaea",
                    },
                  },
                },
              }}
              config={{
                showlegend: true,
                displayModeBar: false,
                editable: false,
                scrollZoom: false,
                responsive: true,
                staticPlot: false,
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkOrderDetail;
